import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";

const saveOrUpdateSettings = async (idUser, formData) => {
  try {
    const response = await api.post(
      UtilsUrl.rhURL() + `/paiementSettings/` + idUser,
      formData
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
const getSettings = async (idUser) => {
  const response = await api.get(
    UtilsUrl.rhURL() + `/paiementSettings/getPaiementSettings/` + idUser
  );
  return response.data;
};
export { saveOrUpdateSettings, getSettings };
